"use client"
import * as __WEBPACK_EXTERNAL_MODULE_react__ from "react";
const FiltersContext = /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react__.createContext)(null);
function useFiltersContext() {
    const context = (0, __WEBPACK_EXTERNAL_MODULE_react__.useContext)(FiltersContext);
    if (!context) throw new Error("useFiltersContext must be used within a Filters component. Make sure to wrap your filter components with <Filters>.");
    return context;
}
export { FiltersContext, useFiltersContext };
